// extracted by mini-css-extract-plugin
export default {"category":"catagory_category__yZdWA","category__container":"catagory_category__container__K3qiP"};